<h1 class="mb-2 title-4 break-words" aria-label="Activity name">
  {{ activity?.name }}
</h1>

<div class="activity-heading text-grey">
  <span *ngIf="sportName">{{ sportName | titlecase }}</span>

  <span *ngIf="displayProficiencyLevel">
    {{ activity?.proficiencyLevel | displayLevel }}
  </span>

  <span *ngIf="hasAgeRange">
    {{ activity?.typicalAgeRange | displayAgeRange }}
  </span>

  <span *ngIf="isPrivate" class="inline-flex items-baseline">
    {{ 'activity.visibility.private' | translate }}
  </span>

  <app-badge
    *ngIf="showExternalPaymentBadge"
    [variant]="badgeVariant.BORDER_GREY"
  >
    {{ 'activity.detail.allow_external_payment' | translate }}
  </app-badge>
</div>
<a
  *ngIf="activityHeaderRatingToggle && reviewCount && averageRating"
  [href]="'#' + reviewsId"
  [attr.aria-label]="'a11y.rating.anchor' | translate"
  [attr.aria-describedby]="reviewsId"
  (click)="anchorHandler($event)"
>
  <app-vtmn-rating
    [compact]="true"
    [showValue]="true"
    [value]="averageRating"
    [comments]="
      'activity.reviews.count-reviews'
        | translate: { reviewQuantity: reviewCount?.toString() }
    "
    [size]="ratingSizeEnum.SMALL"
    [emphasis]="true"
  ></app-vtmn-rating>
</a>
